import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import template from './Edit.vue';

import Button from '@/components/Button';
import MDTextFieldWithValidation from '@/components/Validation/MDTextFieldWithValidation';
import payment from '@/store/modules/payment';
import { Payment, PaymentFormEdit, PaymentType } from '@/store/models/payment';
import store from '@/store';
import auth from '@/store/modules/auth';
import { Query } from '@/store/models';
import { router, validation } from '@/_helpers';
import BackButton from '@/components/BackButton';

@Component({
	mixins: [template],
	components: {
		ValidationObserver,
		Button,
		MDTextFieldWithValidation,
		BackButton
	},
	filters: {
		getType(type: PaymentType): string {
			if (type === PaymentType.CARD) {
				return 'Credit Card';
			}
			if (type === PaymentType.SEPA) {
				return 'SEPA';
			}
			return '-';
		},
		getFour(number: Number): string {
			if (number < 1000) {
				return `0${number}`;
			}
			return `${number}`;
		}
	}
})
export default class PaymentEdit extends Vue {
	loading: boolean = false;

	loadedInit: boolean = false;

	form: PaymentFormEdit = {
		id: '',
		customerId: '',
		isDefault: false,
		billingDetails: {
			name: ''
		},
		type: PaymentType.SEPA
	};

	async mounted(): Promise<void> {
		this.loading = true;

		try {
			// Get self to make sure auth is set
			await auth.getSelf();
			const query: Query = {
				id: this.$route.params.PMid,
				customerID: auth.self.customerId,
				query: {}
			};

			// Get current payment
			await payment.get(query);

			// Set var
			this.form.id = this.$route.params.PMid;
			this.form.customerId = auth.self.customerId;
			this.form.isDefault = payment.payment.isDefault;
			this.form.billingDetails.name = payment.payment.billingDetails.name;
		} catch (error) {
			store.commit('openNotifier', {
				text: 'Er ging iets mis tijdens het binnenhalen van de betaalgegevens.',
				color: 'error'
			});
		} finally {
			this.loadedInit = true;
			this.loading = false;
		}
	}

	get payment(): Payment | undefined {
		return payment.payment;
	}

	cancel(): void {
		router.push({ name: 'payment' });
	}

	async remove(): Promise<void> {
		this.loading = true;

		const query: Query = {
			id: this.$route.params.PMid,
			customerID: auth.self.customerId
		};

		try {
			await payment.delete(query);
			router.push({ name: 'payment' });
		} catch (error) {
			(this.$refs.formEmail as any).setErrors(validation.getErrors(error.data.errors));
		} finally {
			this.loading = false;
		}
	}

	async edit(): Promise<void> {
		const isValid = await (this.$refs.formData as any).validate();
		if (!isValid) {
			return;
		}

		this.loading = true;

		this.form.type = payment.payment.type;

		try {
			await payment.update(this.form);
			router.push({ name: 'payment' });
		} catch (error) {
			(this.$refs.formEmail as any).setErrors(validation.getErrors(error.data.errors));
		} finally {
			this.loading = false;
		}
	}

	doAction(): void {
		const url: string | undefined = this.payment?.action.actionRedirect?.url;

		if (url !== undefined) {
			window.location.href = url;
		}
	}
}
